var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.showFooterBar,
          expression: "showFooterBar"
        }
      ],
      staticClass: "fixed-button-custom btn-tab-group",
      attrs: { id: "fixedbottom" }
    },
    [
      _c("custom-h-r", { staticClass: "mt-0", attrs: { variant: "success" } }),
      _c("div", { staticClass: "col-12 mb-3" }, [
        _c(
          "div",
          { staticClass: "container-foot d-flex justify-content-end" },
          [
            _c(
              "action-button",
              {
                attrs: { i: "fas fa-save", type: "submit", variant: "success" },
                on: { click: _vm.save }
              },
              [_vm._v(" Guardar ")]
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }